import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { STORE_MAIN } from "../Constants";
export const useAuthStore = create(devtools((set) => ({
    accessToken: null,
    setAccessToken: (token) => set({ accessToken: token }),
    apiUrl: null,
    setApiUrl: (url) => set({ apiUrl: url }),
    logout: () => set({
        accessToken: null,
    }),
}), {
    name: STORE_MAIN,
    store: "auth",
}));
